import script from "./DigilockerComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./DigilockerComplete.vue?vue&type=script&setup=true&lang=js"

import "./DigilockerComplete.vue?vue&type=style&index=0&id=4530a324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4530a324"]])

export default __exports__